module.exports = __webpack_public_path__ + "static/media/slide-1.6c96001b.jpg";